import React, { JSX } from 'react'

interface HeadingProps {
  as?: keyof JSX.IntrinsicElements
  children?: React.ReactNode
}

const Heading: React.FC<HeadingProps> = ({ as = 'h1', children }) => {
  return React.createElement(
    as,
    {
      className: `
        py-12 md:py-16 text-center max-w-4xl mx-auto text-2xl md:text-3xl text-[var(--theme-heading-text)] leading-[1.2]
      `
    },
    children
  )
}

export { Heading }